import React, { useEffect } from 'react';
import LoginComponent from '../modules/auth/components/LoginComponent';

const ErrorPageAuth = () => {
	useEffect(() => {
		window.location.pathname = '/';
	}, []);
	
	return <LoginComponent />;
};

export default ErrorPageAuth;